<template>
  <b-modal no-fade v-model="dialog.show" size="sm"  :id="`modal-whitelist-${uniqueId}`"
           :hide-footer="true" centered @close="onDialogClose"
           no-close-on-backdrop
  >
    <template #modal-title>
     <span v-if="loading !== true && error == null && whitelist != null && whitelist.id != null">
       {{ whitelist.email }}
     </span>
    </template>
    <div style="min-height: 600px">
      <div v-if="loading !== true && error == null">
        <whitelist-edit-details v-bind:new-whitelist="isNewWhitelist" v-model="whitelist" @close="closeModal" />
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else-if="loading !== true && error != null">
        <b-alert show variant="danger" >
          <i class="fa-sharp fa-solid fa-triangle-exclamation"></i>
          {{ error }}
        </b-alert>
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else>
        <b-spinner>{{$t('operations.loading')}}</b-spinner>
      </div>
    </div>
  </b-modal>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import { mapActions } from 'vuex'
import WhitelistEditDetails from '@/components/partial/whitelist/WhitelistEditDetails'
import Whitelist from '@/model/whitelist/Whitelist'

export default {
  name: 'whitelistModal',
  components: { WhitelistEditDetails },
  mixins: [mixinBase, mixinNotifications],
  data: () => ({
    dialog: {
      show: false,
    },
    uniqueId: 0,
    loading: true,
    error: null,
    id: null,
    isNewWhitelist: false,
    whitelist: {}
  }),
  watch: {
    queryParams:{
      handler(){
        if(this.queryParams().whitelistId == null) {
          this.closeModal()
          return
        }
        if (this.queryParams().whitelistId !== this.id) {
          this.showModal(this.queryParams().whitelistId)
        }
      },
      deep: true
    }
  },
  created() {
    this.uniqueId = this._uid
    if(this.queryParams().whitelistId != null) {
      this.showModal(this.queryParams().whitelistId)
    }
  },
  methods: {
    ...mapActions('whitelist', ['getWhitelistById']),
    showModal(id) {
      this.id = id
      this.loading = true
      this.dialog.show = true
      this.dialog.tab = 0
      this.isNewWhitelist = this.id == null || this.id === 0;
      if(!this.isNewWhitelist) {
        this.refreshData()
      }else {
        this.whitelist = Whitelist()
        this.error = null
        this.loading = false
      }
      this.pushState({whitelistId: id, tab: 0, })
    },
    closeModal(){
      this.dialog.show = false;
      this.whitelist = {}
      this.onDialogClose()
    },
    onDialogClose(){
      this.id = null;
      this.pushState({whitelistId: null, tab: null, })
    },
    refreshData() {
      let $this = this;
      this.getWhitelistById(this.id)
          .then(whitelist => {
            $this.whitelist = whitelist;
            $this.error = null
            $this.loading = false
          }, err => {
            $this.error = $this.getErrorDescription(err)
            $this.loading = false
          })
    },
  }
}
</script>

<style scoped>

</style>
